import Vue from 'vue';
import { Toast } from 'vant'
Vue.use(Toast)

export default {
  toast(msg = '加载中...', duration = 1000, icon = '') {
    Toast({
      message: msg,
      duration: duration,
      forbidClick: true
    });
  },

  /**
   * loading显示
   * @param msg
   */
  showLoading(msg = '加载中...', duration = 0) {
    Toast.loading({
      message: msg,
      duration: duration,
      forbidClick: true
    });
  },

  /**
   * Loading隐藏
   */
  hideLoading() {
    Toast.loading().clear();
  }
};



// WEBPACK FOOTER //
// ./src/commons/kun.js